import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// import './Footer.css'; // Removed

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleSectionClick = (sectionId) => {
    // If we're already on the home page, just scroll to section
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // If we're on another page, navigate to home first, then scroll to section
      navigate('/');
      // Wait for navigation to complete, then scroll to section
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-primary-500 text-white">
      <div className="container py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Brand Section */}
          <div className="space-y-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center">
                <img 
                  src="/img/dr.Adesh.Palyekar.png" 
                  alt="Dr. Adesh Palyekar" 
                  className="w-12 h-12 rounded-full object-cover"
                />
              </div>
              <div>
                <h3 className="font-display text-xl font-bold">Dr. Adesh Palyekar</h3>
                <p className="text-primary-100 text-sm">Cancer Surgeon</p>
              </div>
            </div>
            
            <p className="text-primary-100 leading-relaxed">
              Providing expert cancer care with compassion and cutting-edge technology. 
              Your health and well-being are our top priorities.
            </p>
            
            <div className="flex gap-4">
              <a 
                href="https://www.youtube.com/channel/UCtK4FLijhS1djNcvdzITSQQ" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="YouTube"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors duration-300"
              >
                <i className="fab fa-youtube text-white"></i>
              </a>
              <a 
                href="https://twitter.com/drpalyekar" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="Twitter"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors duration-300"
              >
                <i className="fab fa-twitter text-white"></i>
              </a>
              <a 
                href="https://www.linkedin.com/in/adesh-palyekar-6881001b6" 
                target="_blank" 
                rel="noopener noreferrer" 
                aria-label="LinkedIn"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors duration-300"
              >
                <i className="fab fa-linkedin text-white"></i>
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-montserrat text-lg font-bold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <button onClick={() => handleSectionClick('services')} className="block text-primary-100 hover:text-white transition-colors duration-300 text-left w-full">Services</button>
              <button onClick={() => handleSectionClick('locations')} className="block text-primary-100 hover:text-white transition-colors duration-300 text-left w-full">Locations</button>
              <button onClick={() => handleSectionClick('testimonials')} className="block text-primary-100 hover:text-white transition-colors duration-300 text-left w-full">Testimonials</button>
              <Link to="/blog" className="block text-primary-100 hover:text-white transition-colors duration-300">Blog</Link>
              <button onClick={() => handleSectionClick('contact')} className="block text-primary-100 hover:text-white transition-colors duration-300 text-left w-full">Contact</button>
            </div>
          </div>
          
          {/* Office Hours */}
          <div className="space-y-4">
            <h4 className="font-montserrat text-lg font-bold mb-4">Office Hours</h4>
            <div className="bg-white/10 rounded-lg p-4">
              <div className="space-y-3 text-sm">
                {/* Header Row */}
                <div className="grid grid-cols-12 gap-2 font-semibold text-primary-200">
                  <span className="col-span-3">Day</span>
                  <span className="col-span-4">Time</span>
                  <span className="col-span-5">Location</span>
                </div>
                
                {/* Data Rows */}
                <div className="space-y-2">
                  <div className="grid grid-cols-12 gap-2">
                    <span className="col-span-3 font-medium">Mon</span>
                    <span className="col-span-4">9:30am - 6:00pm</span>
                    <span className="col-span-5 text-primary-100 break-words">Vision Hospital, Goa</span>
                  </div>
                  <div className="grid grid-cols-12 gap-2">
                    <span className="col-span-3 font-medium">Tue</span>
                    <span className="col-span-4">9:30am - 6:00pm</span>
                    <span className="col-span-5 text-primary-100 break-words">Vision Hospital, Goa</span>
                  </div>
                  <div className="grid grid-cols-12 gap-2">
                    <span className="col-span-3 font-medium">Wed</span>
                    <span className="col-span-4">9:30am - 7:00pm</span>
                    <span className="col-span-5 text-primary-100 break-words">Konkan Cancer and Multispeciality Hospital, Kudal, MH</span>
                  </div>
                  <div className="grid grid-cols-12 gap-2">
                    <span className="col-span-3 font-medium">Thu</span>
                    <span className="col-span-4">9:30am - 7:00pm</span>
                    <span className="col-span-5 text-primary-100 break-words">Konkan Cancer and Multispeciality Hospital, Kudal, MH</span>
                  </div>
                  <div className="grid grid-cols-12 gap-2">
                    <span className="col-span-3 font-medium">Fri</span>
                    <span className="col-span-4">9:30am - 7:00pm</span>
                    <span className="col-span-5 text-primary-100 break-words">Konkan Cancer and Multispeciality Hospital, Kudal, MH</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-primary-400">
          <div className="container py-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-100">
              <span>&copy; {currentYear} Dr. Adesh Palyekar. All Rights Reserved.</span>
              <div className="flex flex-col sm:flex-row items-center gap-4">
                <div className="flex gap-4">
                  <Link to="/privacy-policy" className="hover:text-white transition-colors duration-300">
                    Privacy Policy
                  </Link>
                  <Link to="/cookie-policy" className="hover:text-white transition-colors duration-300">
                    Cookie Policy
                  </Link>
                </div>
                <span>
                  Site by <a href="mailto:admin@flashfish.net" className="hover:text-white transition-colors duration-300">admin@flashfish.net</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 